var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('h1',[_vm._v("Sitemap")]),_c('ul',_vm._l((_vm.links),function(item){return _c('li',{key:item.title},[_c('router-link',{staticClass:"route-link",attrs:{"to":item.url}},[_vm._v(" "+_vm._s(item.title)+" ")])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }